import { Truck, Trees, HardHat, Check, ArrowUpRight } from "lucide-react";
import { SERVICES } from "@/lib/site-data";

const ICONS = { Truck, Trees, HardHat };

export const Services = () => {
  return (
    <section id="services" data-testid="services-section" className="relative py-24 md:py-32 asphalt-thin border-y border-bgtp-line">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
          <div>
            <div className="eyebrow mb-4">Nos prestations</div>
            <h2 className="font-heading text-5xl md:text-7xl uppercase tracking-tight text-white leading-[0.9]">
              Trois métiers, <br className="hidden md:block" />
              <span className="orange-metal-text">une seule équipe.</span>
            </h2>
          </div>
          <p className="max-w-md text-white/70 text-base">
            De la première pelletée à la dernière finition, BGTP intervient sur l'ensemble
            de votre projet — sans sous-traitance, sans surprise.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {SERVICES.map((s, i) => {
            const Icon = ICONS[s.icon] || Truck;
            return (
              <article key={s.key} data-testid={`service-card-${s.key}`} className="industrial-card group">
                <div className="flex items-start justify-between mb-8">
                  <div className="w-14 h-14 flex items-center justify-center border-2 border-bgtp-orange/60 text-bgtp-orange group-hover:bg-bgtp-orange group-hover:text-black transition-colors">
                    <Icon className="w-7 h-7" strokeWidth={2.2} />
                  </div>
                  <div className="font-heading text-bgtp-steel text-2xl tracking-wider">0{i + 1}</div>
                </div>
                <h3 className="font-heading text-3xl uppercase tracking-wider mb-5 text-white">{s.title}</h3>
                <ul className="space-y-3">
                  {s.points.map((p) => (
                    <li key={p} className="flex items-start gap-3 text-white/80 text-sm">
                      <Check className="w-4 h-4 mt-0.5 text-bgtp-orange flex-shrink-0" strokeWidth={3} />
                      <span>{p}</span>
                    </li>
                  ))}
                </ul>
                <div className="mt-8 pt-5 border-t border-bgtp-line flex items-center gap-2 text-xs uppercase tracking-[0.2em] text-bgtp-steel group-hover:text-bgtp-orange transition-colors">
                  En savoir plus <ArrowUpRight className="w-4 h-4" />
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
};
